import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useFailureCauseCategoriesStore = createStore((set) => ({
  status: 'active',
  dateFrom: undefined,
  dateTo: undefined,
  sorting: { ...initialSorting },
  actions: {
    setStatusFilter: (status) => set({ status }),
    setSorting: (sorting) => set({ sorting }),
    setDateRangeFilterDate: ({ dateFrom, dateTo }) => set({ dateFrom, dateTo }),
  },
}));

export const selectFailureCauseCategoriesStatusFilter = () =>
  useFailureCauseCategoriesStore((state) => state.status);

export const selectFailureCauseCategoriesSortingFilter = () =>
  useFailureCauseCategoriesStore((state) => state.sorting);

export const selectFailureCauseCategoriesDateFilter = () =>
  useFailureCauseCategoriesStore((state) => ({
    dateFrom: state.dateFrom,
    dateTo: state.dateTo,
  }));

export const useFailureCauseCategoriesActions = () =>
  useFailureCauseCategoriesStore((state) => state.actions);
